import './sidenav-item.scss'
import { Dispatch, SetStateAction, useRef } from 'react';
import SideNavItemChild from './side-nav-item-child';
import { useSelector } from 'react-redux';
import { RootState } from 'types';

function SideNavItem({
    item,
    onClick,
    active
} : {
    item: any,
    onClick: (data: object, ref?: any) => void,
    active: any
}) {
    const elRef = useRef<any>(null);
    const project = useSelector((state: RootState) => state.project);

    return (
        <div className="sidenav-item">
            <div className={`sidenav-item-heading ${item.children.length ? 'dropdown': ''}`} onClick={e => onClick(item, e.currentTarget.nextSibling)}>
                <span className="icon"><i className={`fal ${item.icon}`}/></span><span className={`heading ${item.disabled ? 'disabled' : ''}`}>{item.name}</span>
                {item.disabled && <i className="fas fa-lock"></i>}
                {item.children.length > 0 && <i className="fal fa-angle-down"></i>}
            </div>
            <div 
                className="sidenav-item-content"
                ref={elRef}
                style={
                    active && active === elRef.current
                        ? { height: elRef.current.scrollHeight, opacity: 1, overflow: 'unset' }
                        : { height: 0, opacity: 0, overflow: 'hidden' }
                }
            >
                {item.children.filter((x: any) => x.projectTypeIds.includes(project.ProjectTypeId)).map((x: any, i: number) => {
                    return (
                        <SideNavItemChild 
                            key={i}
                            item={x}
                            onClick={onClick}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default SideNavItem;